import produce from 'immer';

const INITIAL_STATE = {
  daysWeek: [],
  blockDates: [],
  counties: [],
  quotas: [],
  countiesProduts: [],
};

export default function organRegistration(state = INITIAL_STATE, action) {
  return produce(state, (draft) => {
    switch (action.type) {
      case '@organregistration/ORGAN_DAYSWEEK': {
        draft.daysWeek = action.payload.value;
        break;
      }

      case '@organregistration/ORGAN_BLOCKDATES': {
        draft.blockDates = action.payload.value;
        break;
      }

      case '@organregistration/ORGAN_COUNTIES': {
        draft.counties = action.payload.value;
        break;
      }

      case '@organregistration/MUNICIPIOPRODUTOS': {
        draft.countiesProduts = action.payload.value;
        break;
      }

      case '@organregistration/ORGAN_QUOTAS': {
        draft.quotas = action.payload.value;
        break;
      }

      case '@organregistration/ORGAN_RESETVALUES': {
        draft.daysWeek = [];
        draft.blockDates = [];
        draft.counties = [];
        draft.quotas = [];
        draft.countiesProduts = [];
        break;
      }

      default:
    }
  });
}
